var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYallaOnline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yalla-online"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2645",
    "data-name": "Rectangle 2645",
    width: 16,
    height: 16,
    transform: "translate(39 319)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_345",
    "data-name": "Mask Group 345",
    transform: "translate(-39 -319)",
    clipPath: "url(#yalla-online)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_25_",
    "data-name": "svgexport-6 (25)",
    transform: "translate(39.439 321.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8268",
    "data-name": "Path 8268",
    d: "M3.083,5.314A1.839,1.839,0,1,1,4.939,3.475,1.85,1.85,0,0,1,3.083,5.314Zm0-3.162a1.323,1.323,0,1,0,1.34,1.323A1.333,1.333,0,0,0,3.083,2.152Zm0,0",
    transform: "translate(0.082 0.109)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8269",
    "data-name": "Path 8269",
    d: "M3.912,10.148H.675A.673.673,0,0,1,0,9.478V8.634A3.171,3.171,0,0,1,5.054,6.119a.258.258,0,0,1-.306.415,2.655,2.655,0,0,0-4.231,2.1v.844a.157.157,0,0,0,.158.154H3.912a.258.258,0,1,1,0,.516Zm0,0",
    transform: "translate(0 0.367)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8270",
    "data-name": "Path 8270",
    d: "M14.654,9.965H11.417a.258.258,0,1,1,0-.516h3.237a.156.156,0,0,0,.158-.154V8.451a2.636,2.636,0,0,0-2.649-2.618,2.673,2.673,0,0,0-1.677.592.258.258,0,1,1-.325-.4,3.191,3.191,0,0,1,2-.707,3.153,3.153,0,0,1,3.165,3.134V9.3a.673.673,0,0,1-.675.67Zm0,0",
    transform: "translate(-0.312 0.354)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8271",
    "data-name": "Path 8271",
    d: "M12.149,5.195a1.839,1.839,0,1,1,1.856-1.839A1.85,1.85,0,0,1,12.149,5.195Zm0-3.162a1.323,1.323,0,1,0,1.34,1.323A1.333,1.333,0,0,0,12.149,2.033Zm0,0",
    transform: "translate(-0.297 0.101)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8272",
    "data-name": "Path 8272",
    d: "M10.386,11.041H4.174a.8.8,0,0,1-.748-.838V9.016a4.1,4.1,0,0,1,3.855-4.3,4.1,4.1,0,0,1,3.855,4.3V10.2a.8.8,0,0,1-.748.838ZM7.28,5.229a3.612,3.612,0,0,0-3.4,3.787V10.2a.308.308,0,0,0,.291.322h6.213a.308.308,0,0,0,.291-.322V9.016a3.612,3.612,0,0,0-3.4-3.787Zm0,0",
    transform: "translate(0.228 0.314)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8273",
    "data-name": "Path 8273",
    d: "M7.565,4.725A2.377,2.377,0,0,1,5.18,2.363a2.385,2.385,0,0,1,4.77,0A2.377,2.377,0,0,1,7.565,4.725Zm0-4.209A1.86,1.86,0,0,0,5.7,2.363a1.869,1.869,0,0,0,3.738,0A1.86,1.86,0,0,0,7.565.516Zm0,0",
    transform: "translate(-0.138 0)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYallaOnline);
export default __webpack_public_path__ + "static/media/yalla-online.fade75b7237153a169f077263fab9701.svg";
export { ForwardRef as ReactComponent };